// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hLMY","inner":"styles_inner__DAavU","right":"styles_right__1PIOE","close":"styles_close__aTXlv","footer":"styles_footer__2ZLeq"};